<!-- @catalog Group header row inside a CInputSelect dropdown, to separate result groups (e.g. articles vs FAQs). Label via prop or default slot. -->
<template>
  <q-item-label
    header
    class="c-select-option-header tw-px-4 tw-pb-1 tw-pt-3 tw-text-xs tw-font-semibold tw-uppercase tw-text-gray-500"
  >
    <slot>{{ label }}</slot>
  </q-item-label>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    label?: string;
  }>(),
  {
    label: "",
  },
);
</script>
